import {createContext} from 'react';
import {CBSLoanDetails} from '../../../../../../shared/model/cbs-loans';

export type ConsolidatedLoansContextType = {
  consolidatedLoans: CBSLoanDetails[];
  addLoan: (consolidatedLoans: CBSLoanDetails) => void;
  removeLoan: (consolidatedLoans: CBSLoanDetails) => void;
}

export const ConsolidatedLoansContext = createContext<ConsolidatedLoansContextType>({} as ConsolidatedLoansContextType);